import { render } from "./DashboardAgendaHub.vue?vue&type=template&id=52454282&scoped=true"
import script from "./DashboardAgendaHub.vue?vue&type=script&lang=js"
export * from "./DashboardAgendaHub.vue?vue&type=script&lang=js"

import "./DashboardAgendaHub.vue?vue&type=style&index=0&id=52454282&scoped=true&lang=css"

import exportComponent from "/webserver/websites/dev/intrapaf-v2-public-client-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52454282"]])

export default __exports__